/**
 * Produces a friendly file size string from a number of bytes.
 * E.g. 1024 -> "1 KB", 1048576 -> "1 MB"
 */
export function formatFileSize(bytes: number | undefined): string {
  if (!bytes || bytes === 0) return '0';

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const k = 1024;
  const digits = 2;

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = bytes / Math.pow(k, i);

  // Round to 2 significant digits
  const rounded = parseFloat(size.toPrecision(digits));

  return `${rounded} ${units[i]}`;
}

/**
 * Formats a duration in seconds to a human-readable string.
 */
export function formatDuration(seconds: number | null): string {
  if (seconds === null || seconds < 0) return 'N/A';
  if (seconds < 60) return `${seconds} sec${seconds !== 1 ? 's' : ''}`;
  if (seconds < 3600) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins} min${mins !== 1 ? 's' : ''}${secs > 0 ? ` ${secs} sec${secs !== 1 ? 's' : ''}` : ''}`;
  }
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  return `${hours} hour${hours !== 1 ? 's' : ''}${mins > 0 ? ` ${mins} min${mins !== 1 ? 's' : ''}` : ''}`;
};
